export const BOUNCE_TRANSACTIONS_HEADER = 'Bounce Transactions';
export const OTHER_TRANSACTION_FAILURES_HEADER = 'Other Transaction Failures';
export const BOUNCE_CHARGES_HEADER = 'Bounce & Other Transaction Failure Charges';
export const CASH_AND_CHEQUE_HEADER = 'Cash and Cheque';
export const CREDITS_AND_DEBITS_HEADER = 'Credits and Debits';
export const PAYMENT_METHOD_HEADER = 'Payment Method';

export const BOUNCE_SECTION_HEADERS: ReadonlySet<string> = new Set([
    BOUNCE_TRANSACTIONS_HEADER,
    OTHER_TRANSACTION_FAILURES_HEADER,
    BOUNCE_CHARGES_HEADER,
]);

// Section header is placed above the row carrying one of these labels, header placement is by label; section membership follows payload adjacency.
export const SECTION_HEADER_BY_FIRST_LABEL: Readonly<Record<string, string>> = {
    'No. of Issued Cheque Bounces (Balance Insufficient)': BOUNCE_TRANSACTIONS_HEADER,
    'No. of NACH/ECS Bounce Charges': BOUNCE_CHARGES_HEADER,
    'No. of UPI/IMPS/NEFT/RTGS Failures': OTHER_TRANSACTION_FAILURES_HEADER,
    'Total No. of Cash Deposits': CASH_AND_CHEQUE_HEADER,
    'Total No. of Debit Transactions': CREDITS_AND_DEBITS_HEADER,
    NEFT: PAYMENT_METHOD_HEADER,
    // Legacy underwriting-engine payload: aica-app deploys before underwriting-engine.
    'Total No. of Inward Cheque Bounces': BOUNCE_TRANSACTIONS_HEADER,
};

export const PAYMENT_METHOD_FIRST_LABEL = 'NEFT';

export const BOUNCE_ROW_LABELS: ReadonlySet<string> = new Set([
    'No. of Issued Cheque Bounces (Balance Insufficient)',
    'Amount of Issued Cheque Bounces (Balance Insufficient)',
    'No. of Issued Cheque Bounces (Other Reasons)',
    'Amount of Issued Cheque Bounces (Other Reasons)',
    'No. of UPI/IMPS/NEFT/RTGS Failures',
    'Amount of UPI/IMPS/NEFT/RTGS Failures',
    'No. of Standing Instruction Failures',
    'Amount of Standing Instruction Failures',
    'No. of Cheque Deposited Bounces',
    'Amount of Cheque Deposited Bounces',
    'No. of NACH/ECS Bounce Charges',
    'No. of Issued Cheque Bounce Charges',
    'No. of Deposited Cheque Bounce Charges',
    'No. of Other Transaction Failure Charges',
    'Amount of NACH/ECS Bounce Charges',
    'Amount of Issued Cheque Bounce Charges',
    'Amount of Deposited Cheque Bounce Charges',
    'Amount of Other Transaction Failure Charges',
]);

export const CASH_CHEQUE_ROW_LABELS: ReadonlySet<string> = new Set([
    'Total No. of Cash Deposits',
    'Total Amount of Cash Deposits',
    'Total No. of Cash Withdrawals',
    'Total Amount of Cash Withdrawals',
    'Total No. of Cheque Deposits',
    'Total Amount of Cheque Deposits',
    'Total No. of Cheque Issues',
    'Total Amount of Cheque Issues',
]);

/** Rows whose label cell offers "View Transactions". */
export const ROW_TRANSACTIONS_LABELS: ReadonlySet<string> = new Set([...BOUNCE_ROW_LABELS, ...CASH_CHEQUE_ROW_LABELS]);

export const BOUNCE_AMOUNT_ROW_LABELS: ReadonlySet<string> = new Set(
    [...BOUNCE_ROW_LABELS].filter((label) => label.startsWith('Amount of')),
);

const RUPEE_PREFIX = '₹';

/** Prefixes ₹ on the value of a bounce amount row; callers pass only non-empty values. */
export function formatBounceCellText(label: string, text: string): string {
    return BOUNCE_AMOUNT_ROW_LABELS.has(label) ? `${RUPEE_PREFIX}${text}` : text;
}

/** Rows before the first section-opening label are `main`; each opening label starts a new section. */
export function splitRowsBySection<T extends { classification?: string }>(
    rows: T[],
): { main: T[]; sections: { header: string; rows: T[] }[] } {
    const main: T[] = [];
    const sections: { header: string; rows: T[] }[] = [];
    for (const row of rows) {
        const header = SECTION_HEADER_BY_FIRST_LABEL[row?.classification ?? ''];
        if (header) sections.push({ header, rows: [row] });
        else if (sections.length > 0) sections[sections.length - 1].rows.push(row);
        else main.push(row);
    }
    return { main, sections };
}
